import {isUnlimited} from "@/tools";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTheme} from "@mui/material";

/**
 * A component that displays a number, but if the number is null or undefined, it displays an infinity symbol instead.
 * The color of the infinity symbol can be customized using the unlimitedColor prop.
 */
export const MaybeUnlimitedNumber: React.FC<{
    value: number | null | undefined;
    unlimitedColor?: "primary" | "secondary";
}> = ({value, unlimitedColor}) => {
    const theme = useTheme();
    const color = unlimitedColor ? theme.palette[unlimitedColor].main : undefined;

    if (isUnlimited(value)) return <FontAwesomeIcon icon="infinity" style={{color}} />;
    else return <span>{value}</span>;
};
